// Provides two way conversions between external formats and Filter Query Format

import { OrderedMap } from 'immutable';
import { And, Or } from '../../filterQueryFormat/logic/FilterLogicGroup';
import { TypeToOperator, convertFromExtensibleReportsFilters, convertToExtensibleReportFilter } from './ExtensibleReportFilters';
import invariant from 'react-utils/invariant';

// TODO - currently uses the CRM search format.

const makeOperator = (filter, index, baseFilterFamily, getField) => {
  const {
    operator,
    property
  } = filter;
  const fieldRecord = getField([baseFilterFamily, property]);
  invariant(fieldRecord !== undefined, 'Field record not found for %s', property);
  const Operator = TypeToOperator.get(operator);
  invariant(Operator !== undefined, 'extensible reports `%s` is not defined in OperatorConversion', operator);
  const converter = convertFromExtensibleReportsFilters().get(operator);
  invariant(typeof converter === 'function', 'no converter defined from `%s` to `%s` operator', operator, Operator.toString());
  const value = converter(Operator, fieldRecord, filter);
  return [`${value.field.name} ${value.name} ${index}`, value];
};
const makeLogicGroup = (filterGroup, baseFilterFamily, getField) => {
  return And.of().set('conditions', OrderedMap(filterGroup.filters.map((filter, index) => {
    return makeOperator(filter, index, baseFilterFamily, getField);
  }))).set('filterFamily', baseFilterFamily);
};
export function toDSFilter(value, baseFilterFamily, getField) {
  if (!getField || !value) {
    // Return an empty filter
    return Or.of();
  }
  const {
    filterGroups
  } = value;
  const conditions = filterGroups.map(group => {
    return makeLogicGroup(group, baseFilterFamily, getField);
  });
  return Or.ofRoot().set('conditions', OrderedMap(conditions.map((condition, index) => [`${index}`, condition]))).set('filterFamily', baseFilterFamily);
}
function getFilterGroup(condition) {
  return {
    filters: condition.conditions.map(subCondition => {
      return convertToExtensibleReportFilter(subCondition);
    }).toArray()
  };
}
export function fromDSFilter(logicGroup) {
  const filterGroups = logicGroup.conditions.valueSeq().map(condition => {
    return getFilterGroup(condition);
  }).toJS();
  const filterFamily = logicGroup.get('filterFamily');
  return {
    filterGroups,
    objectTypeId: filterFamily
  };
}